// extracted by mini-css-extract-plugin
export default {"wrapperStyle":"CarbonDischargeTask_wrapperStyle__zInID"};